import { CHANGE_SPEAR_PHISHING_CAMPAIGN_DATA } from '../../WizardSpearPhishingCampaign/constants'
import { RESET_WIZARD, SAVE_DRAFT_ASYNC } from '../constants'

import {
  GET_EMAILS,
  GET_LANDING_DOMAIN_LIST,
  RETRIEVE_EMAIL,
  SPEAR_PHISHING_CAMPAIGN_DATA_POLLING,
  UPDATE_EMAIL,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    notifyGenerationFinishedLoader: false,
    error: null,
    createdSpearPhishingCampaignId: null,
    forcePoll: false,
    emails: [],

    landingDomainCategories: {
      data: [],
      loader: false,
      error: null,
    },

    emailDetails: {
      data: null,
      loader: false,
      error: null,
    },

    emailUpdating: {
      loader: false,
      error: null,
    },
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case RESET_WIZARD:
        return {
          ...initialState,
        }
      case CHANGE_SPEAR_PHISHING_CAMPAIGN_DATA:
        return {
          ...state,
          loader: !action.payload.notifyGenerationFinished,
          notifyGenerationFinishedLoader: action.payload.notifyGenerationFinished,
          error: null,
        }
      case SAVE_DRAFT_ASYNC.SUCCESS:
        return {
          ...state,
          createdSpearPhishingCampaignId: action.payload.id,
          forcePoll: true,
          notifyGenerationFinishedLoader: false,
        }
      case SAVE_DRAFT_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          notifyGenerationFinishedLoader: false,
          error: action.error.detail,
        }
      case SPEAR_PHISHING_CAMPAIGN_DATA_POLLING.SUCCESS:
        return {
          ...state,
          loader: false,
          error: null,
          forcePoll: false,
        }
      case GET_EMAILS.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case GET_EMAILS.SUCCESS:
        return {
          ...state,
          loader: false,
          emails: action.payload.data.items,
        }
      case GET_EMAILS.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error.detail,
        }
      case GET_LANDING_DOMAIN_LIST.INITIATE:
        return {
          ...state,
          landingDomainCategories: {
            data: [],
            loader: true,
            error: null,
          },
        }
      case GET_LANDING_DOMAIN_LIST.SUCCESS:
        return {
          ...state,
          landingDomainCategories: {
            data: action.payload.data,
            loader: false,
            error: null,
          },
        }
      case GET_LANDING_DOMAIN_LIST.ERROR:
        return {
          ...state,
          landingDomainCategories: {
            data: [],
            loader: false,
            error: action.payload.error,
          },
        }
      case GET_LANDING_DOMAIN_LIST.CANCEL:
        return {
          ...state,
          landingDomainCategories: {
            ...state.landingDomainCategories,
            loader: false,
          },
        }
      case UPDATE_EMAIL.INITIATE:
        return {
          ...state,
          emailUpdating: {
            error: null,
            loader: true,
          },
        }
      case UPDATE_EMAIL.SUCCESS:
        return {
          ...state,
          // replace old email on updated one
          emails: state.emails.map((obj) =>
            obj.id === action.payload.data.id ? action.payload.data : obj
          ),
          emailDetails: {
            data: action.payload.data,
          },
          emailUpdating: {
            error: null,
            loader: false,
          },
        }
      case UPDATE_EMAIL.ERROR:
        return {
          ...state,
          emailUpdating: {
            error: action.payload.error,
            loader: false,
          },
        }
      case RETRIEVE_EMAIL.INITIATE:
        return {
          ...state,
          emailDetails: {
            data: null,
            error: null,
            loader: true,
          },
        }
      case RETRIEVE_EMAIL.SUCCESS:
        return {
          ...state,
          emailDetails: {
            data: action.payload.data,
            error: null,
            loader: false,
          },
        }
      case RETRIEVE_EMAIL.ERROR:
        return {
          ...state,
          emailDetails: {
            data: null,
            error: action.payload.error,
            loader: false,
          },
        }
      case RETRIEVE_EMAIL.CANCEL:
        return {
          ...state,
          emailDetails: {
            data: null,
            error: null,
            loader: false,
          },
        }
      default:
        return state
    }
  }
}
